<template>
    <a class="content-tag" :href="linkUrl">
        {{title}}
    </a>
</template>

<script>
    export default {
        name: 'ContentTag',
        props: {
            title: String,
            linkUrl: String
        },
        data () {
            return {};
        },
        methods: {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    .content-tag {
        display: inline-block;
        padding-top: 2px;
        padding-bottom: 3px;
        padding-left: 6px;
        padding-right: 6px;
        margin-right: 4px;
        margin-bottom: 4px;
        min-width: 70px;
        background: #F3F3F3;
        border-radius: 2px;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        color: #999999;
    }
</style>